/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __awaiter, __extends, __generator } from "tslib";
import * as runtime from '../runtime';
/**
 *
 */
var ManagementRestControllerApi = /** @class */ (function (_super) {
    __extends(ManagementRestControllerApi, _super);
    function ManagementRestControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Import locations and player from framen CSV
     * Import locations and player from framen CSV
     */
    ManagementRestControllerApi.prototype.importFramenLocationsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.file !== undefined) {
                            queryParameters['file'] = requestParameters.file;
                        }
                        if (requestParameters.network !== undefined) {
                            queryParameters['network'] = requestParameters.network;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.accessToken) {
                            // oauth required
                            if (typeof this.configuration.accessToken === 'function') {
                                headerParameters["Authorization"] = this.configuration.accessToken("keycloak", []);
                            }
                            else {
                                headerParameters["Authorization"] = this.configuration.accessToken;
                            }
                        }
                        return [4 /*yield*/, this.request({
                                path: "/management/import/framen",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.TextApiResponse(response)];
                }
            });
        });
    };
    /**
     * Import locations and player from framen CSV
     * Import locations and player from framen CSV
     */
    ManagementRestControllerApi.prototype.importFramenLocations = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.importFramenLocationsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return ManagementRestControllerApi;
}(runtime.BaseAPI));
export { ManagementRestControllerApi };
